import Layout from "../../components/Layout/Layout";
import Button from "../../components/Button/Button";
import PageTitle from "../../components/PageTitle/PageTitle";
import CampaignIcon from "@mui/icons-material/Campaign";
import Modal from "../../components/Modal";
import InputGroup from "../../components/FormComponent/InputGroup";
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import useStyles from "./style";
import MailIcon from "@mui/icons-material/Mail";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import Tabs from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Notifications from "./components/Notification";
import CreatedNotification from "./components/CratedNotification";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import { httprequest } from "../../data/api";
import { toast, ToastContainer } from "react-toastify";

const SCHOOLS_ENDPOINT = "/admin/v1/schools";
const NOTIFICATION_ENDPOINT = "/admin/v1/system-notifications";

const Notification = () => {
  const [broacastmodal, setBroadcastModal] = useState(false);
  const [messageContent, setMessageContent] = useState("");
  const [schoolData, setSchoolData] = useState([]);
  const classes = useStyles();
  const [createNotificationModal, setCreateNotificationModal] = useState(false);
  const [notificationData, setNotificationData] = useState({
    type: "",
    title: "",
    message: "",
    start_time: "",
    end_time: "",
    location: []
  });

  const handleBroadcastModal = () => {
    setBroadcastModal(!broacastmodal);
  };

  const handleCreateNotificationModal = () => {
    setCreateNotificationModal(!createNotificationModal);
  };

  const getAllSchools = () => {
    httprequest.get(SCHOOLS_ENDPOINT).then((res) => {
      const schools = res?.data?.data?.schools || [];
      const formattedSchools = schools.map(school => ({
        value: school.school_id,
        label: school.school_name
      }));
      setSchoolData(formattedSchools);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  useEffect(() => {
    getAllSchools();
  }, []);

  const handleCreateNotification = () => {
    const dataToSubmit = {
      ...notificationData
    };

    // eslint-disable-next-line no-console
    console.log(dataToSubmit);
    httprequest.post(NOTIFICATION_ENDPOINT, dataToSubmit)
      .then((res) => {
        toast.success(res.data.message);
        handleCreateNotificationModal();
        setNotificationData({
          type: "",
          title: "",
          message: "",
          end_time: "",
          location: []
        });
        setMessageContent("");
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNotificationData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // const handleSelectChange = (selectedOptions) => {
  //   setNotificationData(prevState => ({
  //     ...prevState,
  //     school_id: selectedOptions.map(option => option.value)

  //   }));
  // };
  const locations = [
    { value: "dashboard", label: "Dashboard" },
    { value: "payment", label: "Payment" },
    { value: "enrollment", label: "Enrollment" },
    { value: "integration", label: "Integration" }
  ];

  const handleLocationChange = (selectedOptions) => {
    setNotificationData(prevState => ({
      ...prevState,
      location: selectedOptions.map(option => option.value) // Update selected locations
    }));
  };

  const handleEditorDrop = (event) => {
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      // Prevent drop if it's a file (e.g., image)
      event.preventDefault();
      event.stopPropagation();
    }
  };
  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      // Check if any pasted item is an image
      if (items[i].type.indexOf("image") !== -1) {
        event.preventDefault(); // Prevent the paste

        return;
      }
    }
  };

  // --| Quill text format is defined explicitly so as to avoid images and videos from being pasted
  const Quillformats = ["background", "bold", "color", "font", "code", "italic", "link", "size",
    "strike", "script", "underline", "blockquote", "header", "indent", "list", "align", "direction", "code-block", "formula"
    // 'image'
    // 'video'
  ];

  const handleQuillChange = (content) => {
    setMessageContent(content);
    setNotificationData(prevState => ({
      ...prevState,
      message: content
    }));
  };

  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Notification"
            subtitle="See the notification from your users at intervals."
            button={
              <div className="flex gap-10">
                <button className={`${classes.button}`}>Clear Notification</button>
                <Button onClick={handleBroadcastModal}
                  buttonSize="fluid" color="btnfontprimary" variant="primaryoutline"
                  buttonName={<div className="flex align-items-center gap-5"><span><CampaignIcon /></span>Send Broadcast</div>}
                />
                <Button
                  onClick={handleCreateNotificationModal}
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  buttonName={<div className="flex align-items-center gap-5"><span><MailIcon /></span>Create Notification</div>}
                />
              </div>
            }
          />
          <TabContext value={value}>
            <div className="tablist-container">
              <Tabs indicatorColor="none" className="overide-tablist" onChange={handleChange} aria-label="">
                <Tab label="Notification" value="1" />
                <Tab label="Created Notification" value="2" />
              </Tabs>
            </div>
            <div className={classes.pagecontent}>
              <div>
                <TabPanel value="1" className="tabpanel-overide">
                  <Notifications />
                </TabPanel>
                <TabPanel value="2" className="tabpanel-overide"><CreatedNotification /></TabPanel>
              </div>
            </div>
          </TabContext>

          {/* SEND BROADCAST MODAL */}
          <Modal
            title="Send Broadcast Message"
            subtitle={
              <div>Here you can send a message to all your users easily.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Title"
                      margin="normal"
                      placeHolder="What is the title of mail."
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="multiple-select">
                      <p className="input-picker-title">
                Message Recipient<span className="input-required">*</span>
                      </p>
                      <Select
                        isMulti
                        options={schoolData}
                        placeholder="Select Recipient"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 9999 })
                        }}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <p style={{ fontWeight: 500, fontSize: "14px" }} className="text-align-left no-margin-block">
                    Broadcast Message
                      <span className="input-required">*</span>
                    </p>
                    <ReactQuill
                      theme="snow"
                      value={messageContent}
                      onDrop={handleEditorDrop}
                      onChange={handleQuillChange}
                      onPaste={handlePaste}
                      formats={Quillformats}
                      modules={{
                        toolbar: [
                          [{ "header": [1, 2, false] }],
                          ["bold", "italic", "underline"],
                          [{ "list": "ordered" }, { "list": "bullet" }],
                          ["clean"] // Remove the image button
                        ]
                      }}
                      style={{
                        borderRadius: 30,
                        textAlign: "left",
                        "& qlContainer": { height: "150px" }
                      }}
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Send broadcast message" />
              </>
            }
            isopen={broacastmodal}
            closeModal={handleBroadcastModal}
          />
          {/* Create Notification MODAL */}
          <Modal
            title="Create Notification"
            subtitle={
              <div>Here you can create a new notification for your users.</div>
            }
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Notification Type"
                      required
                      children={
                        <select
                          name="type"
                          value={notificationData.type}
                          onChange={handleInputChange}
                        >
                          <option value="">--- Select Type---</option>
                          <option value="Information">Information</option>
                          <option value="Warning">Warning</option>
                          <option value="Danger">Danger</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Title"
                      margin="normal"
                      placeHolder="What is the title of the notification."
                      inputType="text"
                      inputName="title"
                      value={notificationData.title}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="multiple-select">
                      <p className="input-picker-title">
                        Select School<span className="input-required">*</span>
                      </p>
                      <Select
                        isMulti
                        options={schoolData}
                        placeholder="Select Recipient"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 9999 })
                        }}
                        onChange={handleSelectChange}
                      />
                    </div>
                  </Grid> */}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <p className="input-picker-title">
                      Select Location(s)<span className="input-required">*</span>
                    </p>
                    <Select
                      isMulti
                      options={locations}
                      placeholder="Select Location(s)"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                      onChange={handleLocationChange} // Update selected locations
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <p style={{ fontWeight: 500, fontSize: "14px", marginBottom: 8 }} className="text-align-left no-margin-block">
                      Notification Message
                      <span className="input-required">*</span>
                    </p>
                    <ReactQuill
                      theme="snow"
                      value={messageContent}
                      onChange={(content) => {
                        setMessageContent(content);
                        setNotificationData(prevState => ({
                          ...prevState,
                          message: content // Update message in notification data
                        }));
                      }}
                      className="quill-editor"
                      style={{
                        borderRadius: 30,
                        textAlign: "left"
                      }}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Starts on:"
                      margin="normal"
                      placeHolder="Starts On"
                      inputType="date"
                      inputMin={new Date().toISOString().split("T")[0]}
                      inputName="start_time"
                      value={notificationData.start_time}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Ends on:"
                      margin="normal"
                      placeHolder="Ends On"
                      inputType="date"
                      inputMin={new Date().toISOString().split("T")[0]}
                      inputName="end_time"
                      value={notificationData.end_time}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Send Notification" onClick={handleCreateNotification} />
              </>
            }
            isopen={createNotificationModal}
            closeModal={handleCreateNotificationModal}
          />
          <ToastContainer />

        </>
      }
    />
  );
};

export default Notification;
